export const ensureHttpsPrefix = (url: string): string => {
    if (/^https?:\/\//i.test(url)) {
        return url;
    }

    return `https://${url}`;
};
